import React from 'react';

import { Divider } from 'ui-components/components/divider';
import { Text, TextType } from 'ui-components/components/text';

import style from './fbs-marketing-stats.module.less';
import { messages } from './messages';

/**
 * @typedef {import('react-intl').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {MessageDescriptor} props.mainText
 * @param {MessageDescriptor} [props.subtext]
 * @returns {React.ReactElement}
 */
const Stat = ({ mainText, subtext }) => {
  return (
    <div className={style.stat}>
      <Text className={style['stat-main-text']} textType={TextType.H2} value={mainText} />
      {subtext ? <Text textType={TextType.Paragraph} value={subtext} /> : null}
    </div>
  );
};

/**
 * @returns {React.JSX.Element}
 */
export const FbsMarketingStats = () => {
  return (
    <div className={style['fbs-marketing-stats']}>
      <Stat mainText={messages.nationwideCoverageText} />
      <Divider orientation={'vertical'} />
      <Stat mainText={messages.orderAccuracyStat} subtext={messages.orderAccuracyLabel} />
      <Divider orientation={'vertical'} />
      <Stat mainText={messages.onTimeStat} subtext={messages.onTimeLabel} />
    </div>
  );
};
